'use strict';

angular.module('ringbaPortal.services').factory('phoneLookupService', phoneLookupService);

function phoneLookupService($http, authService, ngAuthSettings) {
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const service = {
    lookupNumber: lookupNumber
  };
  return service;

  function lookupNumber(accountId, assignmentSettings) {
    const url = serviceBaseUri + accountId + '/phoneNumberLookup';
    return $http.post(url, assignmentSettings,
      {headers: {
        'Content-Type': 'application/json'
      }
      });
  }
}
